import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {ErrorAlertDialogStateData} from "../types/ErrorAlertDialogStateData";

export const useErrorAlertDialog = () => useDialogContext<ErrorAlertDialogStateData>('error-alert');
